import React, { useState } from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Form, Formik } from "formik";
import MyTextInput from "../../../app/common/form/MyTextInput";
import { Button, Checkbox, Grid, Label } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModal } from "../../../app/common/modals/modalReducer";
import { registerEmployerInFirebase } from "../../../app/firestore/firebaseService";
import {
  EMPLOYER_DASHBOARD_MANAGE_JOBS_PATH,
  PRIVACY_POLICY_ROUTE,
  TERMS_AND_CONDITION_ROUTE,
} from "../../../app/api/routeConstants";
import { useHistory } from "react-router-dom";
import { verifyAuth } from "../authActions";
import { SIGN_UP_EMPLOYER_VALIDATION_SCHEMA } from "../../../js/constants/validationSchemas";
import MyPasswordInput from "../../../app/common/form/MyPasswordInput";
import { getMap } from "../../map/mapSelector";
import { getCountryProperties } from "../../data/countries";
import { SIGN_UP_MODAL } from "../../../app/common/modals/ModalManager";
import ReactGA from "react-ga4";
import TextLink from "../../../app/common/components/TextLink";
import BackButton from "../../../app/common/components/BackButton";
import healthcare from "../../../assets/icons/healthcare-icon.svg";
import { HR_ALL_MODE, HR_HEALTHCARE_MODE } from "../../modes/constants";

const SETTINGS_VIEW = 0;
const FORM_VIEW = 1;

export default function SignUpEmployerModal({
  isRecruiter = false,
  initialView = SETTINGS_VIEW,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { isCookieConsent, responsive } = useSelector((state) => state.app);
  const { coverage } = useSelector((state) => getMap(state));

  const country = getCountryProperties(coverage.countryCode);
  const currencyCode = country.currencyCode;

  const [view, setView] = useState(initialView);
  const [isReceiveMarketing, setIsReceiveMarketing] = useState(false);
  const [mode, setMode] = useState(null);

  const selectedBorder = "3px solid #55A6CA";
  const buttonBorder = "1px solid #55A6CA";

  return (
    <ModalWrapper
      style={{ minHeight: 300, width: !responsive.isMobile ? 420 : "90%" }}
      modalClassName={"modal-ux-wrapper"}
      contentClassName={"sign-up-modal-content"}
      showAnimation={"fade"}
      showDuration={450}
      hideAnimation={"fade"}
      hideDuration={160}
    >
      <Grid
        stackable
        className={
          !responsive.isMobile
            ? "sign-up-user-container"
            : "sign-up-container-mobile"
        }
      >
        <Grid.Row style={{ padding: "8px 0 0 0" }}>
          {initialView === SETTINGS_VIEW && (
            <BackButton
              action={() => {
                if (view === SETTINGS_VIEW) {
                  dispatch(openModal({ modalType: SIGN_UP_MODAL }));
                } else {
                  setView(SETTINGS_VIEW);
                }
              }}
            />
          )}
        </Grid.Row>
        {view === SETTINGS_VIEW && (
          <Grid.Row>
            <Grid.Column style={{ padding: 4 }}>
              <h4>Account settings</h4>
              <div>Set up the right account for your company</div>
              <br />
              <div>Advertising jobs in healthcare? </div>
              <div
                className={"display-flex center-flex"}
                style={{ padding: "16px 0" }}
              >
                <Button
                  className={"overwrite-button teal-inverse-button"}
                  type={"button"}
                  content={"Yes"}
                  style={{
                    width: 120,
                    margin: "0 10px 0 0",
                    border:
                      mode === HR_HEALTHCARE_MODE
                        ? selectedBorder
                        : buttonBorder,
                  }}
                  onClick={() => setMode(HR_HEALTHCARE_MODE)}
                />
                <Button
                  className={"overwrite-button teal-inverse-button"}
                  type={"button"}
                  content={"No"}
                  style={{
                    width: 120,
                    margin: "0 10px",
                    border:
                      mode === HR_ALL_MODE ? selectedBorder : buttonBorder,
                  }}
                  onClick={() => setMode(HR_ALL_MODE)}
                />
              </div>
              <div style={{ margin: "10px 0 25px" }}>
                {mode === HR_HEALTHCARE_MODE && (
                  <div>
                    <span>
                      You’re joining{" "}
                      <span className={"semi-bold"}>
                        Hello Radius Healthcare
                      </span>{" "}
                      for pharmacies, clinics and pharmaceutical companies.
                    </span>
                  </div>
                )}
              </div>
              {!!mode && (
                <div style={{ marginBottom: 17 }}>Click next to continue</div>
              )}
              <Button
                className={`overwrite-button ${
                  mode === HR_HEALTHCARE_MODE
                    ? "cta-healthcare-long-button"
                    : "cta-long-button"
                }`}
                type={"button"}
                content={"Next"}
                disabled={!mode}
                onClick={() => setView(FORM_VIEW)}
              />
            </Grid.Column>
          </Grid.Row>
        )}
        {view === FORM_VIEW && (
          <Grid.Row>
            <Grid.Column>
              <div style={{ marginBottom: 20 }}>
                <h2>
                  Create {isRecruiter ? " a Recruiter " : " an Employer "}{" "}
                  Account
                </h2>
              </div>
              <Formik
                initialValues={{
                  displayName: "",
                  email: "",
                  phoneNumber: "",
                  password: "",
                }}
                validationSchema={SIGN_UP_EMPLOYER_VALIDATION_SCHEMA}
                onSubmit={async (values, { setSubmitting, setErrors }) => {
                  try {
                    await registerEmployerInFirebase({
                      values: values,
                      countryCode: country.countryCode,
                      currencyCode: currencyCode,
                      isRecruiter: isRecruiter,
                      isReceiveMarketing: isReceiveMarketing,
                      mode: mode,
                    });
                    if (isCookieConsent) {
                      ReactGA.event({
                        category: "Metrics",
                        action: "User sign-up",
                        label: "Employer",
                      });
                    }
                    setSubmitting(false);
                    dispatch(closeModal());
                    dispatch(verifyAuth());
                    history.push(EMPLOYER_DASHBOARD_MANAGE_JOBS_PATH);
                  } catch (error) {
                    setErrors({ auth: error.message });
                    setSubmitting(false);
                  }
                }}
              >
                {({ isSubmitting, isValid, dirty, errors }) => (
                  <Form className="ui form">
                    <div className="sign-up-field-input-container">
                      <MyTextInput
                        className="form-input-field"
                        name="company"
                        placeholder="Company name*"
                        errorClasses="error-message absolute-position"
                        autoComplete="off"
                      />
                    </div>
                    <div className="sign-up-field-input-container">
                      <MyTextInput
                        className="form-input-field"
                        name="firstName"
                        placeholder="First name*"
                        errorClasses="error-message absolute-position"
                        autoComplete="off"
                      />
                    </div>
                    <div className="sign-up-field-input-container">
                      <MyTextInput
                        className="form-input-field"
                        name="lastName"
                        placeholder="Last name*"
                        errorClasses="error-message absolute-position"
                        autoComplete="off"
                      />
                    </div>
                    <div className="sign-up-field-input-container">
                      <MyTextInput
                        className="form-input-field"
                        name="email"
                        placeholder="Email address*"
                        errorClasses="error-message absolute-position"
                        autoComplete="off"
                      />
                    </div>
                    <div className="sign-up-field-input-container">
                      <MyTextInput
                        className="form-input-field"
                        name="phoneNumber"
                        placeholder="Phone number*"
                        errorClasses="error-message absolute-position"
                        autoComplete="off"
                        type="number"
                        min="0"
                      />
                    </div>
                    <div className="sign-up-field-input-container">
                      <MyPasswordInput
                        name="password"
                        placeholder="Password*"
                        errorClasses="error-message absolute-position"
                        autoComplete="off"
                      />
                    </div>
                    <Checkbox
                      style={{ margin: "20px 10px 10px 0" }}
                      onChange={(e, { checked }) => {
                        setIsReceiveMarketing(checked);
                      }}
                      checked={isReceiveMarketing}
                      label={{
                        children: (
                          <span className="body-text">
                            I would like to receive updates about new features,
                            news and offers.
                          </span>
                        ),
                      }}
                    />
                    <div className="smaller-text">
                      <span>By creating an account you agree to the </span>
                      <TextLink
                        text={"Terms & Conditions"}
                        to={TERMS_AND_CONDITION_ROUTE}
                        fontSize={14}
                        rel="noopener noreferrer"
                        target="_blank"
                      />
                      <span> and </span>
                      <TextLink
                        text={"Privacy Policy"}
                        to={PRIVACY_POLICY_ROUTE}
                        fontSize={14}
                        rel="noopener noreferrer"
                        target="_blank"
                      />
                    </div>
                    <Button
                      className={`overwrite-button ${
                        mode === HR_HEALTHCARE_MODE
                          ? "cta-healthcare-long-button"
                          : "cta-long-button"
                      }`}
                      type={"submit"}
                      loading={isSubmitting}
                      disabled={!isValid || !dirty || isSubmitting}
                      style={{ margin: "20px 0 0 0" }}
                      content={"Sign up"}
                    />
                    {errors.auth && (
                      <div style={{ paddingTop: 10 }}>
                        <Label
                          basic
                          color="grey"
                          style={{ marginBottom: 10 }}
                          content={"Could not sign up with this email"}
                        />
                      </div>
                    )}
                  </Form>
                )}
              </Formik>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
      {view === FORM_VIEW && (
        <div
          className={
            mode === HR_HEALTHCARE_MODE
              ? "sign-up-strapline-healthcare-container"
              : "sign-up-strapline-container"
          }
        >
          <div
            className={
              !responsive.isMobile
                ? "sign-up-strapline-text"
                : "sign-up-strapline-text-mobile"
            }
          >
            {mode === HR_HEALTHCARE_MODE ? (
              <div>
                <img
                  className={"icon-text-button-img"}
                  src={healthcare}
                  style={{
                    width: 24,
                    height: 24,
                    verticalAlign: "middle",
                    marginRight: 10,
                  }}
                  alt="arrow left logo"
                />
                <span style={{ verticalAlign: "middle" }}>
                  Hello Radius Healthcare
                </span>
              </div>
            ) : (
              <>
                <span>hello new job,</span>
                <span> </span>
                <span className={"sign-up-strapline-underline"}>
                  hello new hire
                </span>
                <span className="accent-colour">.</span>
              </>
            )}
          </div>
        </div>
      )}
    </ModalWrapper>
  );
}
